import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { map, mergeMap, catchError, tap, withLatestFrom, exhaustMap, concatMap } from 'rxjs/operators';
import { PartnerService } from '../services/partners.service';
import * as partnerActions from '../store/actions/partners.action';
import * as partnersSelectors from '../store/selectors/partners.selector';
import * as partnerCategories from '../store/categories-partners/categories-action'
import { Store } from '@ngrx/store';
import * as categoryActions from '../store/categories-partners/categories-action'
import { PartnerLocation } from '../models/partners.model';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from '../services/dialog.service';


@Injectable()
export class PartnerEffects {

  loadAllPartners$ = createEffect(() => this.actions$.pipe(
    ofType(partnerActions.loadAllPartners),
    exhaustMap((action) =>
      this.partnerService.getPartners(action.page, action.limit, action.query)
      .pipe(
        map(partners => partnerActions.loadAllPartnersSuccess({ partners })),
        catchError(() => EMPTY)
      ))
    )
  );
  
  searchPartners$ = createEffect(() => this.actions$.pipe(
    ofType(partnerActions.searchPartners),
    exhaustMap((action) =>
      this.partnerService.getPartners(action.page, action.limit, action.query)
      .pipe(
        tap(partners => console.log('Filtered partners loaded from server', partners)),
        map(partners => partnerActions.searchPartnersSuccess({ partners })),
        catchError(() => EMPTY)
      ))
    )
  );

  // loadPartners$ = createEffect(() => this.actions$.pipe(
  //   ofType(partnerActions.loadPartners),
  //   mergeMap(({ page, limit, query }) =>
  //     this.partnerService.searchPartners(page, limit, query)
  //     .pipe(
  //       tap(partners => console.log('Partners loaded from server', partners)),
  //       map(partners => partnerActions.loadPartnersSuccess({ partners })),
  //       catchError(() => EMPTY)
  //     ))
  //   )
  // );

  loadPartner$ = createEffect(() => this.actions$.pipe(
    ofType(partnerActions.loadPartner),
    //uso concatMap porque quuro mantener un orden en las peticiones
    concatMap(({ id }) => this.partnerService.getPartnerDetails(id)
      .pipe(
        map(partnerDetails => partnerActions.loadPartnerSuccess({ partnerDetails })),
        catchError(() => EMPTY)
      ))
    )
  );



  createPartner$ = createEffect(() =>
  this.actions$.pipe(
    ofType(partnerActions.createPartner),
    withLatestFrom(this.store.select((state:any)=> state.partner)),
    concatMap(([action, partnerState]) => {
      const partner = partnerState.partner;
      return this.partnerService.createPartner(partner).pipe(
        map((partner) => {
          this.router.navigate(['/partners']);
          this.snackBar.open(
            'Aliado creado exitosamente!',
            'Cerrar',
            {
              duration: 3000
            }
          );
          return partnerActions.createPartnerSuccess({ partner });
        }),
        catchError((error) =>{
          this.snackBar.open(
            'Los datos ingresados no son correctos o no se han rellenado todos los campos. Por favor verifica tus datos e intenta nuevamente',
            'Cerrar',
            {
              duration: 3000
            }
          );
          return of(partnerActions.createPartnerFailure({ error }));
        })
      )
    })
  )
);



editPartner$ = createEffect(() =>
  this.actions$.pipe(
    ofType(partnerActions.editPartner),
    withLatestFrom(this.store.select((state:any)=> state.partner)),
    mergeMap(([action, partnerState]) => {
      const partner = partnerState.partner;
      return this.partnerService.editPartner(action.id, partner).pipe(
        map((partner) => {
          // Verifica si el diálogo está abierto

            // Si el diálogo no está abierto, navega a la ruta del dashboard
            this.router.navigate(['/partners']);
            this.snackBar.open(
              'Aliado editado exitosamente!',
              'Cerrar',
              {
                duration: 3000
              }
            );
            return partnerActions.editPartnerSuccess({ partner });

        }),
        catchError((error) =>{
          this.snackBar.open(
            'Los datos ingresados no son correctos o no se han rellenado todos los campos. Por favor verifica tus datos e intenta nuevamente',
            'Cerrar',
            {
              duration: 3000
            }
          );
          return of(partnerActions.editPartnerFailure({ error }));
        })
      )
    })
  )
);

editPartnerLocation$ = createEffect(() =>
  this.actions$.pipe(
    ofType(partnerActions.editLocation),
    withLatestFrom(this.store.select((state:any)=> state.partner)),
    mergeMap(([action, locationState]) => {
      console.log(locationState)
      const location = locationState.location;
      const partnerId = locationState.selectedPartnerId;
      return this.partnerService.editPartnerLocation(partnerId, action.id, location).pipe(
        map((location) => {
            this.snackBar.open(
              'Se ha editado exitosamente la ubicación!',
              'Cerrar',
              {
                duration: 3000
              }
            );
            return partnerActions.editLocationSuccess({ location });

        }),
        tap(() => {
          this.store.dispatch(partnerActions.loadLocations({ partnerId: partnerId }));
        }),
        catchError((error) =>{
          this.snackBar.open(
            'Asegurate de rellenar todos campos y de suministrar una url de google maps correcta!',
            'Cerrar',
            {
              duration: 3000
            }
          );
          return of(partnerActions.editPartnerFailure({ error }));
        })
      )
    })
  )
);



addLocation$ = createEffect(() =>
  this.actions$.pipe(
    ofType(partnerActions.addLocation),
    withLatestFrom(this.store.select((state:any)=> state.partner)),
    mergeMap(([action, locationsState]) => {
      const location = locationsState.location;
      const partnerId = locationsState.selectedPartnerId;
      return this.partnerService.addLocation(location).pipe(
        map(location => {
          this.snackBar.open(
            'Se ha creado exitosamente la nueva ubicacion!',
            'Cerrar',
            {
              duration: 3000
            }
          );
          return partnerActions.addLocationSuccess({ location })
        }),
        tap(() => {
          this.store.dispatch(partnerActions.loadLocations({ partnerId: partnerId }));
        }),
        catchError(error => {
          this.snackBar.open(
            'Asegurate de rellenar todos campos y de suministrar una url de google maps correcta!',
            'Cerrar',
            {
              duration: 3000
            }
          );
          return of(partnerActions.addLocationFailure({ error }))})

      )
    })

  )
);

loadPartnerCategories$ = createEffect(() => this.actions$.pipe(
  ofType(categoryActions.loadCategories),
  mergeMap(() => {
    console.log('loadCategories action handled in effect');
    return this.partnerService.getAllCategories().pipe(
      map(categories => {
        console.log('Categories loaded from server', categories);
        return categoryActions.loadCategoriesSuccess({ categories });
      }),
      catchError(error => {
        console.log('Error loading categories from server', error);
        return of(categoryActions.loadCategoriesFailure({ error }));
      })
    );
  })
));

selectPartner$ = createEffect(() => this.actions$.pipe(
  ofType(partnerActions.selectPartner),
  mergeMap(({ partner_id }) => {
    console.log('selectPartner action handled in effect');
    return this.partnerService.getPartnerDetails(partner_id).pipe(
      map(partner => {
        console.log('Partner select loaded from server', partner);
        return partnerActions.selectPartnerSuccess({ partner });
      }),
      catchError(error => {
        console.log('Error loading partner select from server', error);
        return of(partnerActions.selectPartnerFailure({ error }));
      })
    );
  })
));


  constructor(
    private actions$: Actions,
    private partnerService: PartnerService,
    private store: Store,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}
}

